import api from './../helpers/api'

class Userservice {

    //registering a new user
    register(user){

        return api.post(`/auth/register`, {
        firstname: user.firstname,
        lastname: user.lastname,
        username: user.username,
        password: user.password,
        
        }, );
    }

    //get all the users
    getAllUser(){
        return api.get(`/users`,);
    }

    //get a particular user
    getProfile(id){
        
        return api.get(`/profile/${id}`,);
    }
   

    editUser(id, user,permisions){
        return api.put(`/update-user/${id}`,{
            firstname: user.firstname,
            lastname: user.lastname,
            username: user.username,
            password: user.password,
            canManageInventory: permisions.canManageInventory,
            canManageCategory: permisions.canManageCategory,
            canManageSupplier: permisions.canManageSupplier,
            canManagePurchase: permisions.canManagePurchase,
            canSell: permisions.canSell,
            canManageExpense: permisions.canManageExpense,
            canManagePersonel: permisions.canManagePersonel,
            canManageReport: permisions.canManageReport,
            canManageUser: permisions.canManageUser,
            canManageSettings: permisions.canManageSettings,
        },);
    }

    removeUser(id){
        return api.post(`/delete_user/${id}`,{},);
    }
    
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    // logout();
                    location.reload(true);
                }
    
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
    
            return data;
        });
    }

    backup(){
        return api.get(`/backup`,{},)
    }
    
    subscribe(code){
        return api.post(`/subscribe`,{code:code},);
    }
}

export default new Userservice();